import { getPublicRoute, SITE_ORIGIN } from '../../lib/analytics/publicRoutes';
import { webPageStructuredDataGraph } from '../../lib/webPageStructuredData';
import { DSCR_HUB_PATH, isDscrPath } from '../dscr-pages/publication';

export const MORTGAGE_RATES_SCHEMA_ID = 'lw-mortgage-rates-schema';

export function mortgageRatesStructuredDataGraph(pathname: string): object | null {
  if (pathname !== '/mortgage-rates' && !isDscrPath(pathname)) return null;
  const route = getPublicRoute(pathname);
  if (!route?.indexable) return null;
  const url = `${SITE_ORIGIN}${pathname}`;
  const name = pathname === '/mortgage-rates' ? 'California mortgage rates' : route.title.split(' | ')[0];
  const crumbs = [
    { name: 'Home', item: `${SITE_ORIGIN}/` },
    ...(isDscrPath(pathname) ? [{ name: 'Mortgage rates', item: `${SITE_ORIGIN}/mortgage-rates` }] : []),
    ...(isDscrPath(pathname) && pathname !== DSCR_HUB_PATH ? [{ name: 'DSCR rates and quotes', item: `${SITE_ORIGIN}${DSCR_HUB_PATH}` }] : []),
  ];
  crumbs.push({ name, item: url });
  return webPageStructuredDataGraph({ url, name, description: route.description, crumbs });
}
